<!--采用了vue-codemirror脚本编辑器插件来实现python在线编辑器
参考文档：
https://github.com/surmon-china/vue-codemirror

-->
<template>
  <div class="python-editor-content">
    <div class="edit-mask" v-if="!editor"></div>
    <codemirror ref="mycode" v-model="curCode" :options="cmOptions" />
  </div>
</template>
<script>
import { codemirror } from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/theme/base16-dark.css'
import 'codemirror/addon/hint/css-hint.js'
import 'codemirror/addon/hint/show-hint.css'
import 'codemirror/mode/python/python.js'
import 'codemirror/mode/css/css.js'
import 'codemirror/addon/hint/show-hint.js'
import 'codemirror/addon/hint/anyword-hint.js'

// 折叠
import 'codemirror/addon/fold/foldgutter.css'
import 'codemirror/addon/fold/foldcode'
import 'codemirror/addon/fold/foldgutter'
import 'codemirror/addon/fold/brace-fold'
import 'codemirror/addon/fold/comment-fold'
import 'codemirror/addon/fold/markdown-fold'
import 'codemirror/addon/fold/xml-fold'
import 'codemirror/addon/fold/indent-fold'
//自动突出匹配的括号
import 'codemirror/addon/edit/matchbrackets'
// 自动闭合符号
import 'codemirror/addon/edit/closebrackets'
//搜索配置的引入
import 'codemirror/addon/scroll/annotatescrollbar.js'
import 'codemirror/addon/search/matchesonscrollbar.js'
import 'codemirror/addon/search/match-highlighter.js'
import 'codemirror/addon/search/jump-to-line.js'

import 'codemirror/addon/dialog/dialog.js'
import 'codemirror/addon/dialog/dialog.css'
import 'codemirror/addon/search/searchcursor.js'
import 'codemirror/addon/search/search.js'

import bus from '@/utils/bus'
export default {
  components: {
    codemirror,
  },
  model: {
    prop: 'pythonEditorCode',
    event: 'cc',
  },
  props: {
    pythonEditorCode: {
      type: String,
      default: '',
    },
    readOnly: {
      default: false,
    },
    lineNumbers: {
      type: Boolean,
      default: true,
    },
    editor: {
      type: Boolean,
      default: true,
    },
    hint: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      curCode: '',
      cmOptions: {
        tabSize: 4,
        indentWithTabs: true,
        mode: 'python',
        // mode: 'text/javascript',
        // theme: 'monokai',
        theme: 'base16-dark',
        lineNumbers: this.lineNumbers,
        firstLineNumber: 1,
        lineNumberFormatter: (num) => {
          return num + 0
        },
        autoClearEmptyLines: false,
        viewportMargin: 100, //指定当前滚动到视图中内容上方和下方要渲染的行数
        // gutter: true,
        //  gutters: ['CodeMirror-lint-markers'],
        line: true,
        smartIndent: true, // 智能缩进
        indentUnit: 4, // 智能缩进单位为4个空格长度
        foldGutter: true, // 启用行槽中的代码折叠
        lineWrapping: true,
        gutters: [
          'CodeMirror-linenumbers',
          'CodeMirror-foldgutter',
          'CodeMirror-lint-markers',
        ], //代码折叠功能基本配置
        autofocus: true, // 自动聚焦
        matchBrackets: true, // 匹配结束符号，比如"]、}"
        styleSelectedText: true,
        autoCloseBrackets: true, // 自动闭合符号
        styleActiveLine: true, // 高亮选中行的样式
        readOnly: this.readOnly, //是否允许编辑，true/false/“nocursor”:只读外，编辑区域还不能获得焦点
        extraKeys: { 'Ctrl-Space': 'autocomplete' },
        showCursorWhenSelecting: true, //选择时是否显示光标
        hintOptions: {
          completeSingle: false,
        },
      },
    }
  },
  watch: {
    pythonEditorCode: {
      handler(val) {
        this.curCode = val || ''
        // this.curCode = val ||"# python 编辑器\n"
      },
    },
    curCode: {
      handler(val) {
        this.$emit('cc', val)
      },
      immediate: true,
    },
  },
  computed: {
    codemirror() {
      return this.$refs.mycode.codemirror
    },
  },
  created() {
    let self = this
    bus.$on('textToWorkspace', (code) => {
      self.curCode = code
    })
  },
  mounted() {
    let self = this
    self.codemirror.on('keypress', function() {
      if (self.hint) {
        self.codemirror.showHint()
      }
    })
    // self.codemirror.on('cursorActivity', function () {
    //   self.codemirror.showHint()
    // })


  },
  destroyed() {
    bus.$off('textToWorkspace')
  },
  methods: {},
}
</script>
<style scoped lang="scss">
.python-editor-content {
  width: 100%;
  height: 100%;
  overflow: hidden;
  padding-bottom: 50px;
  ::-webkit-scrollbar {
    width: 5px;
    box-shadow: inset006pxrgba(0, 0, 0, 0.7);
    -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.7);
  }
  /* 滚动槽 */
  ::-webkit-scrollbar-track {
    box-shadow: inset006pxrgba(0, 0, 0, 0.7);
    -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.7);
    border-radius: 5px;
  }
  /* 滚动条滑块 */
  ::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #678cff;
    box-shadow: inset006pxrgba(0, 0, 0, 0.7);
    -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.7);
  }
  ::-webkit-scrollbar-thumb:window-inactive {
    background: rgba(109, 119, 150, 0.5);
  }
  .edit-mask {
    width: 100%;
    height: 100%;
    z-index: 10;
    position: absolute;
  }
  ::v-deep .vue-codemirror {
    width: 100%;
    height: 100%;
    .cm-s-base16-dark {
      &.CodeMirror {
        height: 100%;
        background: none;
        font-size: 16px;
      }
      .CodeMirror-linenumber {
        color: #fff;
      }
      .CodeMirror-scroll {
        .CodeMirror-gutters {
          background: none;
        }
      }
      .CodeMirror-hscrollbar {
        height: 5px;
      }
    }
    .CodeMirror-foldgutter-folded:after,.CodeMirror-foldgutter-open:after{
      color:#fff;
    }
    .CodeMirror-dialog-top{
      background: #15234C;
      border-bottom: 2px solid rgba(74, 224, 226, 0.1);
      // border:2px solid rgba(74, 224, 226, 0.1);
    }
  }
}
</style>
